/**
 * useWorkflowAgent Hook
 *
 * Automatically manages the global agent name for workflow modals.
 * Sets the agent name when the workflow mounts and clears it when unmounts.
 *
 * Usage in workflow modals:
 * ```tsx
 * const MyWorkflowModal = ({ agentName = 'myWorkflow', ... }) => {
 *   useWorkflowAgent(agentName);
 *   // ... rest of component
 * }
 * ```
 */

import { useEffect } from 'react';
import { setCurrentAgentName } from '../services/api';

export const useWorkflowAgent = (agentName: string | undefined | null) => {
  useEffect(() => {
    // Set agent name when component mounts
    if (agentName) {
      setCurrentAgentName(agentName);
    }

    // Clear agent name when component unmounts
    return () => {
      setCurrentAgentName(null);
    };
  }, [agentName]);
};

export default useWorkflowAgent;
